import React from "react";
import "./ServiceUnavailable.scss";

const ServiceUnavailable: React.FC = () => {
  return (
    <div className="service-unavailable">
      <h3>
        Passwort per E-Mail zurücksetzen steht aktuell nicht zur Verfügung
      </h3>
      <a
        className="btn-secondary btn-secondary--csc btn-secondary--arrow-right"
        href="/login/passwort-vergessen-sms/"
        target="_self"
        rel="noreferrer"
      >
        Bitte setze dein Passwort jetzt per SMS zurück
      </a>
      <span>
        Wenn du Hilfe brauchst, dann komme zu uns in den Chat oder rufe unsere
        Hotline an. Alle Kontaktwege zu unserem Service findest du{" "}
        <a href="/hilfe-service/kontakt/" target="_self" rel="noreferrer">
          hier
        </a>
        .
      </span>
    </div>
  );
};

export default ServiceUnavailable;
